import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LKModal from '../Modal/Modal';
import LoginTab from './LoginTab';
import ForgotPassword from './ForgotPassword';
import './AuthModal.scss';
import * as registerActions from '../../../actionCreators/auth';
import * as commonActions from '../../../actionCreators/common';
import Register from './Register';
import { getQueryParam } from '../../../utils/helper';


class Auth extends Component {

    constructor(props, context) {
        super(props, context);
        const { openTab, isOffer } = this.props;
        this.state = {
            showModal: true,
            openTab,
            selectedOffer: null
        };
        // When isOffer : true, i.e. Offer Popup is open
        // Then Get selectedOffer from Session Storage
        if (isOffer && sessionStorage.getItem('offerSelected')) {
            this.state.selectedOffer = JSON.parse(sessionStorage.getItem('offerSelected'));
        }
    }

    componentDidMount() {
        const { openTab } = this.state;
        if (window.dtm.LenskartRewamp) {
            if (openTab === 'signin') {
                window.dtm.LenskartRewamp.loginPopup.load.loginPopupSignIn();
            } else {
                window.dtm.LenskartRewamp.loginPopup.load.loginPopupSignUp();
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userInputErr !== this.props.userInputErr && this.props.userInputErr && this.props.userInputErr.status === 401) commonActions.setJunoSession();
    }

    close = () => {
        const { hideLogin, location, isDesktopPdp, renderOfferModal } = this.props;
        // Offer modal : PDP case : on close auth modal, offer modal should also be close.
        if (isDesktopPdp && renderOfferModal) {
            renderOfferModal(false);
        }
        const getLoginType = getQueryParam(location.search.substr(1), 'type');
        if (location.pathname.indexOf('/customer/') === 0 || getLoginType === 'login') {
            window.location.href = '/';
        }
        hideLogin();
        clearInterval(window.secondsTimer);
        _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Close', this.pageInfo]);
        _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Close', this.pageInfo]);
    }

    showSignIn = () => {
        const { registerActions } = this.props;
        registerActions.resetMobileLoginProps();
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.loginPopup.load.loginPopupSignIn();
        this.setState({
            openTab: 'signin'
        });
        _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Show Login', this.pageInfo]);
        _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Show Login', this.pageInfo]);
    }

    showSignUp = () => {
        const { registerActions } = this.props;
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.loginPopup.load.loginPopupSignUp();
        clearTimeout(window.timeOutTimer);
        registerActions.resetMobileLoginProps();
        this.setState({
            openTab: 'signup'
        });
        _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Create Account', this.pageInfo]);
        _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Create Account', this.pageInfo]);
    }

    render() {
        const { showModal, openTab, selectedOffer } = this.state;
        const { hideLogin, allowSignUp, dataLocale, isOffer, login } = this.props;
        const { SIGN_IN, SIGN_UP } = dataLocale;
        return (
            <LKModal size="large" backdrop="static" dialogClassName="auth-modal" hideHandler={this.close} showModal={showModal}>
                <div className="auth-section">
                    <div className="dialog-close">
                        <a onClick={this.close} className="title">X</a>
                    </div>
                    {((!isOffer && openTab !== 'forgotpasswod') || (isOffer && !login)) && (
                        <ul className="auth-section_nav">
                            {allowSignUp && <li className={openTab === 'signup' ? 'TabbedPanelsTab TabbedPanelsTabSelected' : 'TabbedPanelsTab'}>
                                <div onClick={this.showSignUp}>{SIGN_UP}</div>
                            </li>}
                            <li className={openTab === 'signin' ? 'TabbedPanelsTab TabbedPanelsTabSelected' : 'TabbedPanelsTab'}>
                                <div onClick={this.showSignIn}>{SIGN_IN}</div>
                            </li>
                        </ul>
                    )}
                    {openTab === 'signup' && (
                        <Register
                            {...this.props}
                            showSignIn={this.showSignIn}
                            selectedOffer={selectedOffer}
                            // For custom banner img
                            bannerImg={isOffer && selectedOffer && selectedOffer.cat_big_banner ? selectedOffer.cat_big_banner : null}
                        />
                    )}

                    {openTab === 'signin'
                        && (
                            <LoginTab
                                dataLocale={dataLocale}
                                {...this.props}
                                // For custom banner img
                                bannerImg={isOffer && selectedOffer && selectedOffer.cat_big_banner ? selectedOffer.cat_big_banner : null}
                                loginValue={openTab}
                                showPassCallback={() => {
                                    this.setState({ openTab: 'forgotpasswod' });
                                    _gaq.push(['_trackEvent', 'SIGNUP POPUP', 'Forget Password', this.pageInfo]);
                                    _gaq.push(['ninja._trackEvent', 'SIGNUP POPUP', 'Forget Password', this.pageInfo]);
                                }}
                                hideLogin={() => { hideLogin(); }}
                                showSignUp={this.showSignUp}
                            />
                        )}
                    {openTab === 'forgotpasswod'
                        && (
                            <ForgotPassword
                                {...this.props}
                                showLoginCallback={() => {
                                    this.setState({ openTab: 'signin' });
                                    clearTimeout(window.timeOutTimer);
                                }}
                                hideLogin={() => { hideLogin(); }}
                            />
                        )}
                </div>
            </LKModal>
        );
    }
}



const mapStateToProps = state => ({
    registerError: state.auth.registerError,
    register: state.auth.register,
    redisCommonData: state.common.redisCommonData,
    login: state.common.login,
    loginError: state.auth.loginError,
    user: state.auth.user,
    loading: state.auth.loading,
    userInputValidate: state.auth.userInputValidate,
    oTPSent: state.auth.oTPSent,
    userInputErr: state.auth.userInputErr,
    forgotpassError: state.auth.forgotpassError,
    emailStatus: state.auth.emailStatus,
    username: state.auth.username,
    oTPLoginSuccess: state.auth.oTPLoginSuccess,
    social: state.auth.social,
    socialError: state.auth.socialError,
    location: state.router.location,
    dataLocale: state.locale
});

function mapDispatchToProps(dispatch) {
    return {
        registerActions: bindActionCreators(registerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
